<template>
  <div class="flex flex-col">
    <div class="h-12 text-base flex">
      <div class="flex flex-grow items-center">
        <!--<div>Rédigez des contributions {{ charsMax }} signes max</div>-->
        <div v-if="isActive === false" class="flex h-8 mr-3 bg-gray-100 border border-gray-500 rounded select-none">
          <div class="flex items-center justify-center px-2 border-r border-gray-500 cursor-pointer">
            Rédigez
          </div>
          <div
            @click="toggleMenu({ event: $event, name: 'contributions', withIcon: false })"
            class="flex items-center justify-center whitespace-no-wrap px-2 border-r border-gray-500 cursor-pointer"
          >
            <p><b>des</b> contributions</p>
          </div>
          <div
            @click="toggleMenu({ event: $event, name: 'characters', withIcon: false })"
            class="flex items-center justify-center whitespace-no-wrap px-2 border-r border-gray-500 cursor-pointer"
          >
            {{ charsMax }} signes max
          </div>
          <div @click="setCanLike(!canLike)" class="flex items-center justify-center w-12 px-2 cursor-pointer">
            <img v-if="canLike" class="w-5 h-5" src="../assets/icons/canLikeOn.svg" alt="Can like on" />
            <img v-else class="w-5 h-5" src="../assets/icons/canLikeOff.svg" alt="Can like off" />
          </div>
        </div>
      </div>

      <div class="flex py-2 px-3">
        <div v-if="!selected.length" class="flex items-stretch bg-gray-100 border border-gray-500 rounded">
          <div
            @click="toggleMenu({ event: $event, name: 'format' })"
            class="flex items-center justify-center w-12 border-r border-gray-500 cursor-pointer"
          >
            <img class="w-5 h-5" src="../assets/icons/format.svg" alt="Format" />
          </div>
          <div
            @click="toggleMenu({ event: $event, name: 'infos' })"
            class="flex items-center justify-center w-12 cursor-pointer"
          >
            <img class="w-5 h-5" src="../assets/icons/infos.svg" alt="Format" />
          </div>
        </div>
        <div v-if="!selected.length" class="flex items-stretch mx-3 bg-gray-100 border border-gray-500 rounded">
          <div
            @click="toggleMenu({ event: $event, name: 'arrangement', withIcon: false })"
            class="flex items-center justify-center w-12 cursor-pointer"
            :class="{ 'border-r border-gray-500 ': gridMode !== 'free' }"
          >
            <img class="w-5 h-5" :src="arragementIcon()" alt="Format" />
          </div>
          <div
            v-if="gridMode !== 'free'"
            @click="toggleMenu({ event: $event, name: 'order', withIcon: false })"
            class="flex items-center justify-center w-12 border-r border-gray-500 cursor-pointer"
          >
            <img class="h-5" :src="orderedByIcon()" alt="Ordre" />
          </div>
          <div
            v-if="gridMode !== 'free'"
            @click="toggleMenu({ event: $event, name: 'filter', withIcon: false })"
            class="flex items-center justify-center w-12 cursor-pointer"
          >
            <img class="w-5 h-5" src="../assets/icons/filter.svg" alt="Filtre" />
          </div>
        </div>

        <!-- Menu sélection -->
        <div v-if="selected.length" class="flex items-stretch mx-3 bg-gray-100 border border-gray-500 rounded">
          <div
            v-if="
              ((selected.length === 1 && !isLastOfGroup(selected[0])) || gridMode !== 'group') && gridMode !== 'label'
            "
            @click="setGridMode('group')"
            class="flex items-center justify-center w-12 border-r border-gray-500 cursor-pointer"
          >
            <img class="w-5 h-5" src="../assets/icons/inlineGroups.svg" alt="Grouper" />
          </div>
          <div
            v-if="selected.length > 1"
            class="flex items-center justify-center w-12 border-r border-gray-500 cursor-pointer"
          >
            <div
              v-if="selected.length > 1"
              @click="merge({ withFirst: false })"
              class="flex items-center justify-center w-12 cursor-pointer"
            >
              <img
                class="w-5 h-5"
                src="../assets/icons/mergeWithLast.svg"
                alt="Fusionner avec le dernier sélectionné"
              />
            </div>
          </div>
          <div
            v-if="selected.length > 1 || isSelectedAnswerMerged"
            class="flex items-center justify-center w-12 border-r border-gray-500 cursor-pointer"
          >
            <div
              v-if="selected.length > 1"
              @click="merge({ withFirst: true })"
              class="flex items-center justify-center w-12 cursor-pointer"
            >
              <img
                class="w-5 h-5"
                src="../assets/icons/mergeWithFirst.svg"
                alt="Fusionner avec le premier sélectionné"
              />
            </div>
            <div
              v-if="selected.length === 1 && isSelectedAnswerMerged"
              @click="unmerge({ parentAnswerOrder: selected[0] })"
              class="flex items-center justify-center w-12 cursor-pointer"
            >
              <img class="w-8 h-8" src="../assets/icons/unmerge.svg" alt="Fusionner" />
            </div>
          </div>
          <div @click="deleteSelected()" class="flex items-center justify-center w-12 cursor-pointer">
            <img class="w-5 h-5" src="../assets/icons/bin.svg" alt="Supprimer" />
          </div>
        </div>

        <div class="flex items-center w-12 bg-gray-100 border border-gray-500 rounded">
          <div
            @click="toggleMenu({ event: $event, name: 'select', withIcon: false })"
            class="flex h-full items-center text-blue justify-center w-12 cursor-pointer relative"
          >
            <img class="absolute m-auto w-8 h-8" src="../assets/icons/select.svg" alt="Sélection" />
            {{ selected.length }}
          </div>
        </div>

        <div class="flex items-center w-12 ml-3 bg-gray-100 border border-gray-500 rounded">
          <div
            @click="toggleMenu({ event: $event, name: 'otherDisplays', withIcon: false })"
            class="flex h-full items-center text-blue justify-center w-12 cursor-pointer relative"
          >
            <img class="absolute m-auto w-8 h-8" src="../assets/icons/labelsDisplay.svg" alt="Sélection" />
          </div>
        </div>

        <div class="flex items-stretch mx-3 bg-gray-100 border border-gray-500 rounded">
          <div
            @click="toggleMenu({ event: $event, name: 'label', withIcon: false })"
            class="flex items-center justify-center w-12 border-r border-gray-500 cursor-pointer relative label-menu"
          >
            <ul v-if="labels.length > 5" class="absolute top-0" style="left: 2px">
              <li
                v-for="(label, index) in labels.slice(6, labels.length)"
                :key="index"
                class="rounded-full"
                :style="'width:4px;height:4px;margin-top:1px;background-color:' + getLabelColors(label.guid_text).bg"
              ></li>
            </ul>
            <img class="h-5" src="../assets/icons/label.svg" alt="Label" />
            <ul v-if="labels.length > 1" class="absolute top-0" style="right: 2px">
              <li
                v-for="(label, index) in labels.slice(0, 6)"
                :key="index"
                class="rounded-full"
                :style="'width:4px;height:4px;margin-top:1px;background-color:' + getLabelColors(label.guid_text).bg"
              ></li>
            </ul>
          </div>
          <div
            @click="toggleMenu({ event: $event, name: 'new', withIcon: false })"
            class="flex items-center justify-center w-12 border-r border-gray-500 cursor-pointer"
          >
            <img class="w-8 h-8 -mt-2" src="../assets/icons/new.svg" alt="Nouvelle contribution" />
          </div>
          <div @click="bounce()" class="flex items-center justify-center w-12 cursor-pointer">
            <img class="w-8 h-8 -mt-2" src="../assets/icons/bounce.svg" alt="Rebond" />
          </div>
        </div>

        <div v-if="history.length > 0" class="flex items-stretch bg-gray-100 border border-gray-500 rounded mr-3">
          <div
            @click="undo()"
            class="flex items-center justify-center w-12 cursor-pointer"
          >
            <img class="w-6 h-6" src="../assets/icons/undo.svg" alt="Annuler la suppression" />
          </div>
        </div>

        <div class="flex items-stretch bg-gray-100 border border-gray-500 rounded">
          <div
            @click="toggleMenu({ event: $event, name: 'sync', withIcon: false })"
            class="flex items-center justify-center w-12 cursor-pointer"
          >
            <img class="w-6 h-6" src="../assets/icons/sync.svg" alt="Sync" />
          </div>
        </div>
      </div>

      <div class="bg-gray-100 flex items-stretch border border-gray-300">
        <div class="flex items-center pr-2 border-r border-gray-300">
          <div class="px-2">{{ itemsCount }}</div>
          <div class="w-5">
            <img class="w-5 h-5" src="../assets/icons/contribution.svg" alt="Contribution" />
          </div>
        </div>
        <div class="flex items-center">
          <div
            @click="toggleMenu({ event: $event, name: 'live', withIcon: false, alignTopRight: true })"
            class="whitespace-no-wrap cursor-pointer select-none w-40 h-full"
          >
            <ParticipationState />
          </div>
        </div>
      </div>

      <Menus
        v-if="activeMenu"
        class="menu"
        :name="activeMenu"
        :position="menuPosition"
        :withIcon="withIcon"
        :editedIndex="editedIndex"
        :label="label"
        :alignTopRight="alignTopRight"
        :realItemsPerLine="realItemsPerLine"
        @closeMenu="closeMenu"
        @toggleMenu="deepToggleMenu($event)"
      />
    </div>

    <GridMenuLabels
      @toggleMenu="toggleMenu"
      @resizeLabels="$emit('resizeLabels')"
      :selected="selected"
      :realItemsPerLine="realItemsPerLine"
      :itemSizeWithMargins="itemSizeWithMargins"
      :labelColumnWidth="labelColumnWidth"
    />
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex"
import Menus from "./menus/Menus"
import GridMenuLabels from "./GridMenuLabels"
import ParticipationState from "./ParticipationState"

export default {
  props: {
    itemsCount: Number,
    charsMax: Number,
    canLike: Boolean,
    orderedBy: String,
    selected: Array,
    gridMode: String,
    realItemsPerLine: Number,
    itemSizeWithMargins: Object,
    labelColumnWidth: Number,
  },
  data() {
    return {
      activeMenu: null,
      menuPosition: { top: 0, left: 0 },
      withIcon: true,
      editedIndex: null,
      alignTopRight: false,
      previousMenu: null,
      label: null,
      arragementIcon() {
        try {
          switch (this.gridMode) {
            case "free":
              return require("@/assets/icons/freeModeMenu.svg")
            case "grid":
            case "label":
              return require("@/assets/icons/gridModeMenu.svg")
            case "group":
              return require("@/assets/icons/groupModeMenu.svg")
          }
        } catch (e) {
          return null
        }
      },
      orderedByIcon() {
        try {
          switch (this.orderedBy) {
            case "numbers":
              return require("@/assets/icons/numbersOrdered.svg")
            case "likes":
              return require("@/assets/icons/likesOrdered.svg")
            case "labels":
              return require("@/assets/icons/labelsOrdered.svg")
            case "labelsNumbers":
              return require("@/assets/icons/labelsNumbersOrdered.svg")
            case "labelsLikes":
              return require("@/assets/icons/labelsLikesOrdered.svg")
            default:
              return require("@/assets/icons/ordered.svg")
          }
        } catch (e) {
          return null
        }
      },
    }
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels.all,
      selectedLabels: (state) => state.labels.selected,
      isActive: (state) => state.live.isActive,
      history: (state) => state.undo.history,
    }),
    ...mapGetters("answers", ["selectedIsAGroup", "oneSelectedIsInAGroup", "isLastOfGroup", "isSelectedAnswerMerged"]),
    ...mapGetters("labels", ["getLabelColors"]),
  },
  components: {
    Menus,
    GridMenuLabels,
    ParticipationState,
  },
  methods: {
    ...mapMutations("grid", ["setGridMode"]),
    ...mapMutations("question", ["setCanLike"]),
    ...mapMutations("answers", ["merge", "unmerge"]),
    ...mapActions("answers", ["deleteSelected"]),
    ...mapActions("socketppt", ["bounce"]),
    ...mapActions("undo", ["undo"]),
    deepToggleMenu(event) {
      if (event.previousMenu !== undefined) {
        this.previousMenu = event.previousMenu
      }
      this.closeMenu()
      this.toggleMenu(event)
    },
    toggleMenu({ event = null, name, withIcon = true, editedIndex = null, alignTopRight = false, label = null }) {
      this.withIcon = withIcon
      this.editedIndex = editedIndex
      this.label = label

      if (this.activeMenu === null || this.activeMenu !== name) {
        this.activeMenu = name
        this.alignTopRight = alignTopRight
        if (event !== null) {
          this.menuPosition = this.getMenuPosition(event.target)
        }
        return
      }

      this.closeMenu()
    },
    closeMenu() {
      this.activeMenu = null
      if (this.previousMenu !== null) {
        this.toggleMenu(this.previousMenu)
      }
    },
    getMenuPosition(target) {
      let menuSourceElement

      if (target.tagName === "IMG" || target.tagName === "P") {
        menuSourceElement = target.parentElement
      } else {
        menuSourceElement = target
      }

      let menuSourceElementRect = menuSourceElement.getBoundingClientRect()

      if (this.alignTopRight) {
        return {
          top: menuSourceElementRect.bottom + 5,
          right: menuSourceElementRect.right,
        }
      }
      return {
        top: menuSourceElementRect.bottom + 5,
        left: menuSourceElementRect.left,
      }
    },
  },
}
</script>

<style></style>
